import { render, staticRenderFns } from "./SVGLoader.vue?vue&type=template&id=3a6b985c&"
import script from "./SVGLoader.vue?vue&type=script&lang=ts&"
export * from "./SVGLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports